import React, {memo} from 'react';
import {useSelector} from 'react-redux';
import {layoutSelectors} from 'features/layout/redux';
import {State} from 'redux/reducer';
import StateIcon from './StateIcon';

const DiplomatStateStatusIcon = memo(({name, folderId}: {name: string; folderId: string}) => {
   const status = useSelector((state: State) => layoutSelectors.getStatus(state, folderId, name));
   return <StateIcon status={status} />;
});

export default DiplomatStateStatusIcon;
